import React from "react";
import { Box, colors, Menu, MenuItem } from "@mui/material";
import {
  BodyLarge,
  H7TitleLarge,
  H9TitleSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import Styled from "@emotion/styled";
import usePoolsPageContext from "../../context/usePoolsPageContext.js";
import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import ActionDialog from "../../../components/ActionDialog/ActionDialog.js";
import useSiteAndGroupTreeContext from "../../../minerstatusV2/context/useSiteAndGroupTreeContext.js";
import { usePostSiteConfig } from "../../queries/usePostSiteConfig.ts";
import { usePostDGConfig } from "../../queries/usePostDGConfig.ts";
import {StyledMenu, StyledMenuItem} from "../../../components/StyledComponents/Menu/Menu.tsx";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

export const PoolCardMenu = (props) => {
  const {colors} = useTheme()
  const {
    anchorEl,
    handleMenuClose,
    handleMenuItemClick,
    index,
    url,
    user,
    password,
    worker,
  } = props;

  return (
    <StyledMenu
      colors={colors}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
  
    >
      <StyledMenuItem   
        colors={colors}
        onClick={() => handleMenuItemClick("edit", index)}
      >
        Edit
      </StyledMenuItem>
      <StyledMenuItem
        colors={colors}
        disabled={
          !url && !user && !password && !worker
        }
        onClick={() => handleMenuItemClick("delete", index)}
      >
        Delete
      </StyledMenuItem>
    </StyledMenu>
  );
};

const PoolCard = (props) => {
  const {
    url,
    user,
    password,
    worker,
    index,
    configData,
    refetch,
    role,
  } = props;
  const { colors } = useTheme();
  const {
    setOpenAddConfigModal,
    mockData,
    setMockData,
    setPoolDataToEdit,
    setEditModeOn,
    deletionDialogMessage,
    deletionDialogOpen,
    setDeletionDialogOpen,
    setDeleteDialogHeaderMessage,
    setDeletionDialogMessage,
    deleteDialogHeaderMessage,
    deletionOrEditIndex,
    setDeletionOrEditIndex,
  } = usePoolsPageContext();

  const { setToastOpen, setToastMessage } =
    useAppContextProvider();

  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const { mutate: postSiteConfig } = usePostSiteConfig();
  const { mutate: postGroupConfig } = usePostDGConfig();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    setDeletionOrEditIndex(index);
    if (option === "edit") {
      handleMenuClose();
      const data = {
        index: index,
        url: url,
        user: user,
        password: password,
        worker: worker,
      };

      setOpenAddConfigModal(true);
      setEditModeOn(true);
      setPoolDataToEdit(data);
      // setConfigModalInEditMode(true);
    }
    if (option === "delete") {
      handleMenuClose();
      setDeletionDialogOpen(true);
      setDeleteDialogHeaderMessage(
        `Delete Pool Configuration ${index + 1}`
      );
      setDeletionDialogMessage(
        "Are you sure you want to delete this pool configuration? This action cannot be undone."
      );
    }
  };
  const handleDeletionDialogClose = () => {
    setDeletionDialogOpen(false);
  };

  const handlePoolConfigurationDeletion = () => {
    if (siteSelectedName && !groupSelectedName) {
      const newPool = {
        url: "",
        user: "",
        pass: "",
        worker: "",
      };
      const poolsDataModified = configData.poolCfg?.map(
        (pool, poolIndex) => {
          if (poolIndex === deletionOrEditIndex) {
            return {
              ...newPool,
            };
          }
          return pool;
        }
      );

      const siteDataModified = {
        ...configData,
        poolCfg: poolsDataModified,
      };
      postSiteConfig(
        {
          siteName: siteSelectedName,
          config: {
            ztp: {
              ...siteDataModified,
            },
          },
        },
        {
          onSuccess: async (res) => {
            if (res.status === "error") {
              setToastOpen(true);
              setToastMessage(
                `Error deleting pool ${
                  deletionOrEditIndex + 1
                } from ${siteSelectedName}. ${res.msg}`
              );
              await refetch();
              handleDeletionDialogClose();
            } else {
              setToastOpen(true);
              setToastMessage(
                `Pool ${
                  deletionOrEditIndex + 1
                } deleted from ${siteSelectedName}`
              );
              await refetch();
              handleDeletionDialogClose();
            }
          },
          onError: (err) => {
            setToastOpen(true);
            setToastMessage(
              `Error deleting pool ${
                deletionOrEditIndex + 1
              } from ${siteSelectedName}`
            );
            handleDeletionDialogClose();
          },
        }
      );
    } else {
      const newPool = {
        url: "",
        user: "",
        pass: "",
        worker: "",
      };
      const poolsDataModified = configData.poolCfg?.map(
        (pool, poolIndex) => {
          if (poolIndex === deletionOrEditIndex) {
            return {
              ...newPool,
            };
          }
          return pool;
        }
      );

      const groupDataModified = {
        ...configData,
        poolCfg: poolsDataModified,
      };
      postGroupConfig(
        {
          siteName: siteSelectedName,
          dgname: groupSelectedName,
          config: {
            ztp: {
              ...groupDataModified,
            },
          },
        },
        {
          onSuccess: async (res) => {
            if (res.status === "error") {
              setToastOpen(true);
              setToastMessage(
                `Error deleting pool ${
                  deletionOrEditIndex + 1
                } from ${siteSelectedName}-${groupSelectedName}. ${
                  res.msg
                }`
              );
              await refetch();
              handleDeletionDialogClose();
            } else {
              setToastOpen(true);
              setToastMessage(
                `Pool ${
                  deletionOrEditIndex + 1
                } deleted from ${siteSelectedName} - ${groupSelectedName}`
              );
              await refetch();
              handleDeletionDialogClose();
            }
          },
          onError: (err) => {
            setToastOpen(true);
            setToastMessage(
              `Error deleting pool ${
                deletionOrEditIndex + 1
              } from ${siteSelectedName} - ${groupSelectedName}. ${err}`
            );
            handleDeletionDialogClose();
          },
        }
      );
    }
  };

  return (
    <Box
      display={"grid"}
      gap={"1.5rem"}
      sx={{
        padding: "1.25rem 2rem 2rem 2rem",
        borderRadius: "1.5rem",
        backgroundColor: colors?.background?.accent,
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <H7TitleLarge>{`Pool ${index + 1}`}</H7TitleLarge>
        <StyledIconButton
          colors={colors}
          disabled={
            role !== "superadmin" && role !== "pooladmin"
          }
          onClick={handleMenuOpen}
        >
          <MoreVertIcon />
        </StyledIconButton>
        <PoolCardMenu
          {...{
            anchorEl,
            handleMenuClose,
            handleMenuItemClick,
            index,
            url,
            user,
            password,
            worker,
          }}
        />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 3fr", // Flexible columns
          gap: "1rem",
        }}
      >
        {[
          { label: "URL", value: url },
          { label: "User", value: user },
          { label: "Password", value: password },
          {
            label: "Worker Identifier",
            value: worker,
          },
        ].map(({ label, value }, index) => (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <H9TitleSmall>{label}</H9TitleSmall>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <BodyLarge>{value}</BodyLarge>
            </Box>
          </React.Fragment>
        ))}
      </Box>
      <ActionDialog
        open={deletionDialogOpen}
        onClose={handleDeletionDialogClose}
        headerMessage={deleteDialogHeaderMessage}
        subMessage={deletionDialogMessage}
        deleteAction={handlePoolConfigurationDeletion}
        buttonText={"Delete"}
      />
    </Box>
  );
};

export default PoolCard;
